import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { EntityConfigService } from "../services/entity-config-service";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { UsageService } from "../services/usage-service";
import { AdminConfigService } from "../services/admin-config-service";
import { DateLocaleService } from "../services/date-locale-service";
import { ModalService } from "../services/modal-service";

import * as angular from "angular";

namespace TimeSpans {
    export var Daily = "Daily";
    export var Weekly = "Weekly";
    export var Monthly = "Monthly";
    export var Quarterly = "Quarterly";
    export var Annually = "Anually";
}

enum SplitMethod {
    Evenly = 0,
    UnevenPercent = 1,
    UnevenAmount = 2,
    Blank = 3
}

enum DueDateMethod {
    EachRow = 0,
    Recurring = 1,
    Blank = 2
}

export function RLBulkCreateAmounts(): ng.IDirective {
    return {
        template: require("/assets/app/templates/bulk-create-amounts.html"),
        restrict: 'E',
        scope: {
            usages: '=',
            onSave: '&',
            onCancel: '&'
        },
        controller: BulkCreateAmountsController,
        controllerAs: 'bcaVM',
        bindToController: true
    }
}

interface IMultiValidateScope extends ng.IScope {
    validate: () => boolean;
    group: string;
}

MultiValidate.$inject = ['$parse', '$rootScope'];
export function MultiValidate($parse: ng.IParseService, $rootScope: ng.IRootScopeService): ng.IDirective {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            validate: "&rlMultiValidate",
            group: '@?'
        },
        link: ($scope: IMultiValidateScope, $elem: ng.IAugmentedJQuery, $attrs: ng.IAttributes, ngModelCtrl: ng.INgModelController) => {
            $scope.group = $scope.group || 'default';

            ngModelCtrl.$viewChangeListeners.push(() => {
                $rootScope.$broadcast(`multiValidate${$scope.group}`)
            });

            $scope.$on(`multiValidate${$scope.group}`, (event) => {
                ngModelCtrl.$setValidity(`multiValidate${$scope.group}`, $scope.validate());
            });
        }
    }
}

// TODO: Make all validators from charDataDirectives directives and update the charData templates to use them, removing the validator code
export function PercentValidator(): ng.IDirective {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: ($scope, $ele, $attrs, ngModelCtrl: ng.INgModelController) => {
            ngModelCtrl.$viewChangeListeners.push(() => {
                var valid = true;
                var value = ngModelCtrl.$viewValue;
                if (!_.isEmpty(value)) {
                    var numValue = parseFloat(value);
                    if (!/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value) || Math.abs(numValue) > 100) {
                        valid = false;
                    }
                }

                ngModelCtrl.$setValidity('percentage', valid);
            });
        }
    }
}

class BulkCreateAmountsController {
    static $inject = ['$scope', '$q', 'entityConfigService', 'entityService', 'notifyService', 'usageService', 'adminConfigService', 'dateLocaleService', 'modalService'];
    /** directive scope variables **/
    usages: Models.IUsageRow[];

    initialized = false;
    usageMetaData: Models.ICharacteristicMetaData[];

    usageFee: number;
    usageCurrency: string;

    amountTemplates: Models.ICharacteristicTemplate[];
    selectedAmountTemplate: Models.ICharacteristicTemplate;
    numberOfRows: number = 1;
    splitMethods = SplitMethod;
    splitMethod: SplitMethod = SplitMethod.Evenly;
    usageFees: { [entityID: string]: number };

    usageHasProjects = false;
    usageHasAssets = false;
    amountCanHaveCatalog = false;
    amountCatalogAllowsUsageCatalogTemplates = true;
    catalogTemplatesNotAllowed: string[] = [];
    perCatalogChecked = false;
    usageCatalogTemplates: { [index: string]: string } = {};

    canInputAmounts = false;
    canInputPercents = false;


    splitAmounts: { [index: string]: string };
    splitPercents: { [index: string]: string };
    totalPercent: number = 0;

    onSave: (any) => void;
    onCancel: () => void;

    dueDateMethod = DueDateMethod.Blank;
    dueDates: { [index: string]: string } = {};
    viewDueDates: { [index: string]: string } = {};
    timeSpans: string[];
    selectedTimeSpan: string;
    startDate: string;
    datePlaceholder: string;
    dueDateRequired = false;
    hasDueDate = true;
    hasValidUsageConfig = true;
    hasValidAmountConfig = true;

    //MVCA-3143
    copyTableValuesToAmounts = true;

    isCompanyCurrencySet = false;

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private entityConfigService: EntityConfigService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private usageService: UsageService,
        private adminConfigService: AdminConfigService,
        private dateLocaleService: DateLocaleService,
        private modalService: ModalService) {

        $scope.$watch(() => this.splitPercents, (newValue) => {
            if (newValue) {
                this.totalPercent = 0;
                for (var index in this.splitPercents) {
                    this.totalPercent += parseFloat(this.splitPercents[index]);
                }
            }
        }, true);

        $scope.$watch(() => this.usages, (newValue, oldValue) => {
            if (newValue && newValue.length > 0) {
                this.setupUsageFees();
                this.$q.all([this.getAssociatedAmountTemplates(), this.getUsageMetaData(this.usages[0]), this.setUsageCatalogTemplates(this.usages), this.checkCompanyCurrencySet()])
                    .finally(() => {
                        if (this.isCompanyCurrencySet) {
                            this.initialized = true;
                        }
                        else {
                            this.initialized = false;
                            alert("There is no company currency set. Please set company currency or contact your administrator to set up company currency.");
                            this.onCancel();
                        }
                    });

            }
        }); 

        $scope.$watch(() => this.selectedAmountTemplate, (newValue, oldValue) => {
            if (newValue) {
                this.catalogTemplatesNotAllowed = [];
                this.amountCatalogAllowsUsageCatalogTemplates = true;
                this.entityService.getEmptyEntityCharData(Utils.IdBuilder.buildTemplateID(0, Consts.CharTypeIDs.amount, newValue.templateID))
                    .then((res) => {
                        this.entityConfigService.getCharTypeTemplateAssociationList(Consts.CharTypeIDs.amount, newValue.templateID).then((templatesResult) => {
                            this.amountCanHaveCatalog = _.any(templatesResult.templateAssociationList, assc => assc.childCharTypeID == Consts.CharTypeIDs.property && assc.selected);

                            // check for any of the usages catalog templates that are not valid templates to have under the amount
                            _.keys(this.usageCatalogTemplates).forEach((ct) => {
                                if (!_.any(templatesResult.templateAssociationList, (at) => at.childTemplateID == parseInt(ct) && at.selected)) {
                                    this.amountCatalogAllowsUsageCatalogTemplates = false;
                                    this.perCatalogChecked = false;
                                    if (!_.contains(this.catalogTemplatesNotAllowed, this.usageCatalogTemplates[ct])) {
                                        this.catalogTemplatesNotAllowed.push(this.usageCatalogTemplates[ct])
                                    }
                                }
                            });

                            const dueDateCmd = _.find(res.templateMetaData.characteristicMetaDatas, (cmd) => {
                                return cmd.tagLabel === 'due_date';
                            });

                            const amountAmountCmd = _.find(res.templateMetaData.characteristicMetaDatas, (cmd) => {
                                return cmd.systemIndicator == Consts.SystemIndicators.Amount.Amount;
                            });

                            this.hasValidAmountConfig = !!amountAmountCmd;

                            if (!dueDateCmd) {
                                this.hasDueDate = false;
                            } else {
                                this.hasDueDate = true;
                                if (dueDateCmd.requiredIndicator > 0) {
                                    this.dueDateRequired = true;
                                }
                            }
                        });
                    });
            }
        });

        $scope.$watchCollection(() => [this.numberOfRows, this.dueDateMethod, this.startDate, this.selectedTimeSpan], (newValue: [number, DueDateMethod, string, string], oldValue) => {
            if (newValue[0] && newValue[1] && newValue[2] && newValue[3]) {
                if (this.dueDateMethod == DueDateMethod.Recurring) {
                    var date = this.startDate;
                    this.viewDueDates = {};
                    moment.locale(navigator.language);
                    for (var i = 0; i < this.numberOfRows; i++) {
                        // We could just start i at 1 but I find that harder to read
                        if (i === 0) {
                            this.viewDueDates[i] = date;
                            continue;
                        }

                        switch (this.selectedTimeSpan) {
                            case TimeSpans.Daily: {
                                date = moment(date, "L").add(1, 'day').format("L");
                                this.viewDueDates[i] = date;
                                break;
                            }
                            case TimeSpans.Weekly: {
                                date = moment(date, "L").add(7, 'day').format('L');
                                this.viewDueDates[i] = date;
                                break;
                            }
                            case TimeSpans.Monthly: {
                                date = moment(date, "L").add(1, 'month').format('L');
                                this.viewDueDates[i] = date;
                                break;
                            }
                            case TimeSpans.Quarterly: {
                                date = moment(date, "L").add(3, 'month').format('L');
                                this.viewDueDates[i] = date;
                                break;
                            }
                            case TimeSpans.Annually: {
                                date = moment(date, "L").add(1, 'year').format('L');
                                this.viewDueDates[i] = date;
                                break;
                            }
                        }
                    }
                }
            }
        });
        this.timeSpans = [];
        for (var key in TimeSpans) {
            this.timeSpans.push(TimeSpans[key]);
        }
        moment.locale(navigator.language);
        this.datePlaceholder = moment(new Date()).localeData().longDateFormat('L');
    }

    //need a list of all catalog templates for all usages to ensure they can be created under a catalog item
    private setUsageCatalogTemplates(usages: Models.IUsageRow[]) {
        return usages.forEach(u => {
            _.keys(u.catalogItems).forEach((c) => {
                var divID = Utils.IdBuilder.splitEntityID(u.entityID).divID;
                this.entityService.getEntityRecord(Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.property, parseInt(c))).then((rec) => {
                    this.usageCatalogTemplates[rec.templateID] = rec.template;
                });
            })
        });
    }

    private getRowCount(usage: Models.IUsageRow) {
        return this.perCatalogChecked ? this.numberOfRows * _.values(usage.catalogItems).length : this.numberOfRows;
    }

    private getUsageCatalog(usage: Models.IUsageRow, index: number) {
        return _.values(usage.catalogItems)[_.floor(index / this.numberOfRows)];
    }

    private getPercentageSplit(usage: Models.IUsageRow, index: number) {
        if (_.keys(this.splitPercents).length == 0) {
            return 0;
        }
        var x = this.perCatalogChecked ? index % this.numberOfRows : index;
        return this.perCatalogChecked ? (this.usageFees[usage.entityID] / _.keys(usage.catalogItems).length) * (parseFloat(this.splitPercents[x]) / 100) : this.usageFees[usage.entityID] * (parseFloat(this.splitPercents[x]) / 100);
    }

    private getUsageMetaData(usage: Models.IUsageRow) {
        var entityID = Utils.IdBuilder.splitEntityID(usage.entityID);

        return this.entityService.getEmptyEntityCharData(Utils.IdBuilder.buildTemplateID(entityID.divID, entityID.charTypeID, usage.templateID))
            .then((res) => {
                this.usageMetaData = res.templateMetaData.characteristicMetaDatas;

                const cmd = _.find(this.usageMetaData, (cmd) => {
                    return cmd.systemIndicator === Consts.SystemIndicators.UsageTotalFee;
                });

                const currencyCmd = _.find(this.usageMetaData, (cmd) => {
                    return cmd.systemIndicator == Consts.SystemIndicators.Currency;
                });

                var fees: string[] = [];
                this.usages.forEach((usage) => {
                    const feeCol = _.find(usage.columns, (col) => {
                        return col.systemIndicatorID == Consts.SystemIndicators.UsageTotalFee;
                    });

                    if (feeCol != undefined) {
                        fees.push(feeCol.value);
                    }

                    if (currencyCmd != undefined) {
                        const currCol = _.find(usage.columns, (col) => {
                            return col.systemIndicatorID == currencyCmd.systemIndicator;
                        });
                        if (currCol != undefined) {
                            this.usageCurrency = currCol.value;
                        }
                    }

                    if (!cmd || (!currencyCmd && cmd.dataTypeID != Consts.CharDataTypeIDs.CharDataTypes.money) || !feeCol) {
                        this.hasValidUsageConfig = false;
                    }
                });

                if (_.uniq(fees).length === 1) {
                    this.usageFee = parseFloat(fees[0]);
                    this.canInputAmounts = true;
                }
            });
    }

    private getAssociatedAmountTemplates() {
        var templateIDs = _.chain(this.usages)
            .map((usage) => { return usage.templateID })
            .uniq()
            .value();

        if (templateIDs.length > 1) {
            throw new Error('Usages of multiple Templates selected. This shouldn\'t even be allowable in the UI');
        }

        return this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.usage, templateIDs[0], Consts.CharTypeIDs.amount)
            .then((res) => {
                this.amountTemplates = res;
            });
    }

    private checkCompanyCurrencySet() {
        return this.adminConfigService.getCompanyCurrency()
            .then((result) => {
                if (!_.isEmpty(result.data)) {
                    this.isCompanyCurrencySet = true;
                }
            });
    }

    private setupUsageFees() {
        this.usageFees = {};
        var canInputAmounts = true;
        var canInputPercents = true;

        var firstFee: number = undefined;

        var usageHasFeeChar: { [entityID: string]: boolean } = {};

        this.usages.forEach((usage) => {
            if (Object.keys(usage.catalogItems).length > 0) this.usageHasAssets = true;
            if (Object.keys(usage.projectItems).length > 0) this.usageHasProjects = true;

            usageHasFeeChar[usage.entityID] = false;

            usage.columns.forEach((col) => {
                if (col.systemIndicatorID == Consts.SystemIndicators.UsageTotalFee) {
                    usageHasFeeChar[usage.entityID] = true;

                    if (col.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.currency) {

                        if (firstFee != undefined) {
                            firstFee = parseFloat(col.value);
                        }
                        this.usageFees[usage.entityID] = parseFloat(col.value);
                    }
                    else if (col.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
                        if (col.value != null) {
                            var val = col.value.split(" ")[1].replace(/,/g, '');
                            this.usageCurrency = col.value.split(" ")[0];

                            if (firstFee != undefined) {
                                firstFee = parseFloat(val);
                            }
                            this.usageFees[usage.entityID] = parseFloat(val);
                        }
                    }
                }
            });

            // if no fee char or not set, they can split by amounts only
            if (!this.usageFees[usage.entityID]) {
                if (canInputPercents) {
                    canInputPercents = false;
                }
            }

            if (canInputAmounts && firstFee != this.usageFees[usage.entityID]) {
                canInputAmounts = false;
            }
        });

        this.canInputAmounts = canInputAmounts;
        this.canInputPercents = canInputPercents;

        // set default split method
        if (!this.canInputPercents) {
            this.splitMethod = SplitMethod.UnevenAmount;
        } else {
            this.splitMethod = SplitMethod.Evenly;
        }
    }

    public Range(num: number) {
        return _.range(0, num);
    }

    public Cancel() {
        this.splitAmounts = undefined;
        this.splitPercents = undefined;
        this.splitMethod = SplitMethod.Evenly;
        if (this.onCancel) {
            this.onCancel();
        }
    }

    public ValidatePercents(): boolean {
        if (this.splitPercents && _.keys(this.splitPercents).length == this.numberOfRows) {
            var total = 0;
            for (var index in this.splitPercents) {
                total += parseFloat(this.splitPercents[index]);
            }

            return total === 100;
        } else {
            return true;
        }
    }

    public ValidateAmounts(): boolean {
        if (!this.usageFee) {
            return true;
        }
        else if (this.splitAmounts && _.keys(this.splitAmounts).length == this.numberOfRows) {
            var total: number = 0;
            for (var index in this.splitAmounts) {
                total += parseFloat(this.splitAmounts[index]);
            }

            return total == this.usageFee;
        } else {
            return true;
        }
    }

    private getSplitValues(): { [index: string]: string } {
        switch (this.splitMethod) {
            case SplitMethod.UnevenAmount: {
                return this.splitAmounts;
            }
            case SplitMethod.UnevenPercent: {
                return this.splitPercents;
            }
            default: return {};
        }
    }

    public CreateAmounts(form: ng.IFormController) {
        if (form.$valid) {
            var divID = Utils.IdBuilder.splitEntityID(this.usages[0].entityID).divID;

            var parentRelRecIDs: number[] = [];

            this.usages.forEach((usage) => {
                parentRelRecIDs.push(usage.relRecID);
            });

            var dueDates: { [index: string]: string } = {};
            var dueDateKeys = _.keys(this.dueDates).map((key) => _.parseInt(key));

            _.forEach(dueDateKeys, (key) => {
                var dueDate = this.dueDates[key];
                var moment = this.dateLocaleService.parseMoment(dueDate);
                if (moment.isValid()) {
                    var storageMoment = this.dateLocaleService.delocalizeMoment(moment);
                    dueDates[key] = storageMoment.format("L");
                } else {
                    dueDates[key] = "";
                }
            });

            var startDate = "";
            if (!_.isEmpty(this.startDate)) {
                var moment = this.dateLocaleService.parseMoment(this.startDate);
                if (moment.isValid()) {
                    var storageMoment = this.dateLocaleService.delocalizeMoment(moment);
                    startDate = storageMoment.format("L");
                }
            }

            this.notifyService.startProgress();
            this.usageService.bulkCreateAmounts(parentRelRecIDs,
                Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.amount, this.selectedAmountTemplate.templateID),
                this.numberOfRows, this.perCatalogChecked, this.splitMethod,
                this.splitMethod == SplitMethod.UnevenAmount || this.splitMethod == SplitMethod.UnevenPercent ? this.getSplitValues() : {},
                this.dueDateMethod,
                this.dueDateMethod == DueDateMethod.Recurring ? this.selectedTimeSpan : undefined,
                this.dueDateMethod == DueDateMethod.Recurring ? startDate : undefined,
                this.dueDateMethod == DueDateMethod.EachRow ? dueDates : {}, this.copyTableValuesToAmounts)
                .then((result) => {
                    this.notifyService.endProgress();
                    if (!_.isEmpty(result.jobID)) {
                        var progressStatus: string = "";
                        this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, true)
                            .then((jobProgressResult) => {
                                if (jobProgressResult.status == "Done") {
                                    if (this.onSave) {
                                        let newlyCreatedAmountEntityIDs = jobProgressResult.resultMessage.split(",");
                                        this.onSave({ entityIDs: newlyCreatedAmountEntityIDs });
                                    }
                                }
                            });
                    }

                });
        }
    }
}

export class BulkAmountsModalController {
    static $inject = ['$uibModalInstance', 'usages']

    usages: Models.IUsageRow[];

    constructor(private $uibModal: ng.ui.bootstrap.IModalServiceInstance, usages: Models.IUsageRow[]) {
        this.usages = usages;
        $uibModal.rendered.then(() => {
            angular.element("body").addClass("modal-open");
        });
    }

    public Saved(entityIDs: string[]) {
        this.$uibModal.close(entityIDs);
    }

    public Canceled() {
        this.$uibModal.dismiss('cancel');
    }
}